import { render, staticRenderFns } from "./HistoricoOficinas.vue?vue&type=template&id=791aa9e1"
import script from "./HistoricoOficinas.vue?vue&type=script&lang=js"
export * from "./HistoricoOficinas.vue?vue&type=script&lang=js"
import style0 from "./HistoricoOficinas.vue?vue&type=style&index=0&id=791aa9e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports